import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import isEqual from 'lodash-es/isEqual';
import axios from 'axios';
import { isMobileOnly } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';

import loadable from '../../../../utils/loadable';

import Preloader from '../../../Preloader';
import StoryFilters from '../../../StoryFilters';
import StoryCard from '../../../TrendingStories/StoryCard';
import RecommendedStories from '../../../RecommendedStories';
import NewStoriesButton from '../../../Buttons/NewStoriesButton';
import OpenFiltersButton from '../../../StoryFilters/StoryFiltersButton/OpenFiltersButton';
import PiwikContext from '../../../../services/piwikContext';
import StoryCaughtUp from '../../../StoryCaughtUp';
import Summarisation from '../../../Summarisation';

import withMetatag from '../../../../decorators/metadataDecorators/metatagsTitleDecorator';
import withComponentName from '../../../../decorators/withComponentName';

import permissionsDecorator from '../../../../decorators/permissionsDecorator';

import * as searchActions from '../../../../actions/searchActions';
import * as watchlistActions from '../../../../actions/watchlistActions';
import * as storyActions from '../../../../actions/stories.actions';
import * as preferencesActions from '../../../../actions/preferencesActions';
import * as commonActions from '../../../../actions/common.actions';

import { getStories, loadWatchlistStories } from '../../../../services/dbServices/watchlistDbServices';
import StoriesSvc from '../../../../services/StoriesSvc';
import StorageSvc from '../../../../services/StorageSvc';

import {
  compareFilters,
  watchlistTopicsQueryCreator,
  checkAllAssetsStatus,
  compareUserViewFilters,
} from '../../../../helpers/helpers';
import { getBrowserScrollTop, pickParams } from '../../../../helpers/commonHelpers';
import { filterSelectedSentimentForStories } from '../../../../helpers/storyHelpers';
import {
  queryItemWatchlistParser,
} from '../../../../helpers/watchlistHelperFunctions';
import { filterSelectedTimeFilter } from '../../../../helpers/timeFilterHelpers';
import { filterSourceDomains } from '../../../../helpers/filtersHelpers';

import { UPDATE_SCROLL_BOTTOM_DISTANCE, STORIES_LIMIT } from '../../../../data/filters/storyFilters';
import { SILVER } from '../../../../data/permissions';

import Styles from './styles.module.scss';

const Masonry = loadable(() => import('react-masonry-component'));

const cx = classNames.bind(Styles);

export class WatchlistNews extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    this.state = {
      scrollPosition: 0,
      personalisationExpand: false,
      filterOpened: false,
      width: 0,
      newStoriesAvailable: false,
      newStoriesLoading: false,
      storyUpdateApiCall: false,
      isWatchlistUpdated: false,
    };

    this.isScrolling = 0;
    this.storyUpdateTimer = 0;
    this.loadStoriesTimeout = null;
    this.scrollDivTop = 0;
    this.isTabActive = false;

    this.storiesRef = createRef();
    this.storiesContainerRef = createRef();
    this.mobileNewStoriesRef = createRef();
    this.recommendedRef = createRef();

    this.cancelToken = axios.CancelToken;
    this.sourceCancelToken = this.cancelToken.source();
  }

  componentDidMount() {
    this.isTabActive = true;
    const expandStories = JSON.parse(StorageSvc.getItem('expandStories'));
    const userNewsfeedViewImages = JSON.parse(StorageSvc.getItem('userNewsfeedViewImages'));
    this.setState({
      ...expandStories,
      ...userNewsfeedViewImages,
    });
    const { actions, storyFilters } = this.props;
    actions.activatePreloader();
    this.loadStories(storyFilters);
    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('focus', this.onFocus, { passive: true });
    this.onResize();

    if (window.innerHeight <= 768) {
      window.addEventListener('scroll', this.onScrollLoadData);
    } else {
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }
    window.addEventListener('visibilitychange', this.onVisibilityChange);
  }

  componentDidUpdate(props, state, shouldStoriesUpdate) {
    const {
      scrollUpPressed,
      actions,
      promobarHeight,
      storyFilters,
      activeWatchlist,
      token,
      activeWatchlistTopics,
    } = this.props;
    const { newStoriesAvailable } = this.state;
    const { activeWatchlist: prevActiveWatchlist } = props;

    if (promobarHeight !== props.promobarHeight && newStoriesAvailable) {
      this.onScroll();
    }

    if (activeWatchlist?.id !== prevActiveWatchlist?.id) {
      actions.activatePreloader();
    }

    if (shouldStoriesUpdate && activeWatchlist.id) {
      const currentId = activeWatchlistTopics.map(({ id }) => id);
      const oldId = props.activeWatchlistTopics.map(({ id }) => id);
      const isUpdated = !isEqual(currentId, oldId);

      this.scrollToStart(false);
      this.setState(({ isWatchlistUpdated }) => ({
        newStoriesAvailable: false,
        isWatchlistUpdated: isWatchlistUpdated || isUpdated,
      }), () => {
        this.loadStories(storyFilters);
      });
    }

    if (scrollUpPressed) {
      actions.toggleScrollUpState(false);
      this.scrollToStart(false);
    }

    if (!token && !compareUserViewFilters(storyFilters, props.storyFilters)) {
      this.forceUpdate();
    }
  }

  getSnapshotBeforeUpdate(prevProps) {
    const {
      storyFilters: prevStoryFilters,
      activeWatchlistTopics: prevActiveWatchlistTopics,
      activeWatchlist: prevActiveWatchlist,
    } = prevProps;
    const { storyFilters, activeWatchlistTopics, activeWatchlist } = this.props;

    return (
      !compareFilters(storyFilters, prevStoryFilters)
      || !isEqual(prevActiveWatchlistTopics, activeWatchlistTopics)
      || activeWatchlist?.id !== prevActiveWatchlist?.id
    );
  }

  componentWillUnmount() {
    const { actions } = this.props;

    clearInterval(this.interval);
    clearTimeout(this.loadStoriesTimeout);
    this.isTabActive = false;
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('focus', this.onFocus);
    window.removeEventListener('visibilitychange', this.onVisibilityChange);
    if (this.sourceCancelToken) this.sourceCancelToken.cancel();
    actions.freezeStories(false);
  }

  onResize() {
    this.setState({
      width: window.innerWidth,
    });
    this.setScrollUpButtonPosition();
  }

  onScroll() {
    const {
      promobarHeight, stories, guestStories,
    } = this.props;
    const { nextPageToken } = this.state;

    if (!this.storiesContainerRef.current) {
      return;
    }

    clearTimeout(this.isScrolling);
    this.isScrolling = setTimeout(() => {
      const { scrollPosition } = this.state;
      const { freezeStories, actions } = this.props;

      const scrollTop = getBrowserScrollTop();
      if (
        Math.abs(scrollPosition - scrollTop) > 250
        && freezeStories
      ) {
        actions.freezeStories(false);
      }
      this.setState({
        scrollPosition: scrollTop,
      });
    }, 100);

    const storiesTop = this.storiesContainerRef.current.getBoundingClientRect().top;
    const isFilterFixed = (storiesTop - 40 - promobarHeight - 20) <= 0;

    const newStoriesTop = this.mobileNewStoriesRef.current.getBoundingClientRect().top;
    const isNewStoriesFixed = (newStoriesTop - 40 - 20) <= 0;

    this.setScrollUpButtonPosition();

    this.setState({
      isFilterFixed,
      filterTop: promobarHeight + 40,
      isNewStoriesFixed,
    });

    const storyData = () => (stories.length ? stories : guestStories);

    if (storyData().length < 20 && nextPageToken !== 'EOD') {
      this.onScrollLoadData();
    }
  }

  onVisibilityChange() {
    if (document.hidden) {
      clearTimeout(this.loadStoriesTimeout);
      this.loadStoriesTimeout = 0;
      if (this.sourceCancelToken) this.sourceCancelToken.cancel();
      this.isTabActive = false;
    } else {
      if (!this.sourceCancelToken) this.sourceCancelToken = this.cancelToken.source();
      clearTimeout(this.storyUpdateTimer);
      this.storyUpdateTimer = 0;
      this.isTabActive = true;
      const { storyFilters } = this.props;
      this.loadStories(storyFilters);
    }
  }

  onFocus() {
    const { watchlistLoadError } = this.props;
    if (watchlistLoadError) {
      this.setState({
        newStoriesAvailable: false,
      }, () => {
        const { storyFilters } = this.props;
        this.loadStories(storyFilters);
      });
    }
  }

  async onScrollLoadData() {
    const { storyUpdateApiCall } = this.state;
    const { activatePreloader, nextPageToken } = this.props;
    if (this.newStoriesFetching || activatePreloader || storyUpdateApiCall) return;

    if (nextPageToken !== 'EOD') {
      this.newStoriesFetching = true;
      await this.fetchNewStories();
      this.newStoriesFetching = false;
    }
  }

  async onStoryScroll(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setScrollUpButtonPosition();
    const { nextPageToken, promobarHeight } = this.props;
    const { storyUpdateApiCall } = this.state;
    const { currentTarget } = e;

    const { top } = currentTarget.getBoundingClientRect();

    // Tab height 40 + story margin 10 + 5 extra space = 55
    if (top - promobarHeight - 55 > 0 && currentTarget.scrollTop > this.scrollDivTop) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop < currentTarget.scrollTop) {
        window.scrollTo({
          top: currentTarget.scrollTop,
        });
      }
    }

    this.scrollDivTop = currentTarget.scrollTop;

    if (this.newStoriesFetching || storyUpdateApiCall) return;

    if (currentTarget.scrollTop + currentTarget.clientHeight > currentTarget.scrollHeight - UPDATE_SCROLL_BOTTOM_DISTANCE && nextPageToken !== 'EOD') {
      this.newStoriesFetching = true;
      await this.fetchNewStories();
      this.newStoriesFetching = false;
    }
  }

  onStoryHide(id) {
    const { actions } = this.props;
    actions.hideWatchlistStory(id);
  }

  setScrollUpButtonPosition() {
    if (!this.storiesRef.current) return;

    const storiesRect = this.storiesRef.current.getBoundingClientRect();
    let topCSS = storiesRect.height - 48;
    if (storiesRect.top > 0) {
      topCSS = storiesRect.height - storiesRect.top - 48;
    }

    this.setState({ scrollUpTop: topCSS });
  }

  getParams(filters) {
    const { isAdvancedLayout } = this.props;
    const {
      token, accessLevels, activeWatchlistTopics, activeSentimentTab,
    } = this.props;
    const hasSilverAccess = accessLevels.includes(SILVER);
    const params = pickParams(
      { ...filters },
      'categories', 'order_by', 'selected_time_filter', 'languages', 'min_score', 'translate_to',
      'all_languages', 'blacklisted_domain_ids', 'whitelisted_domain_ids', 'domains_filtering_mode',
      ...filterSelectedTimeFilter(filters.selected_time_filter),
      ...filterSelectedSentimentForStories(filters, hasSilverAccess),
      'isRefresh',
    );

    params.premium_only = filters.premium_content_only;
    params.fold_similar_stories = filters.group_similar_stories;
    params.include_all_topics = checkAllAssetsStatus(activeWatchlistTopics);
    if (params.all_languages) delete params.languages;

    if (isAdvancedLayout && activeSentimentTab !== 'all') {
      params.sentiment_levels = activeSentimentTab;
    }

    if (!params.include_all_topics) {
      params.query = watchlistTopicsQueryCreator(
        // Include no more that 33 topics to not exceed URL length limit (2048 characters)
        activeWatchlistTopics.filter((item) => !item.hidden).slice(0, 33),
        token,
      );
    }

    return params;
  }

  scrollToStart(fetchNewStories = true) {
    const {
      storyFilters,
    } = this.props;
    const WLTabBar = document.getElementById('watchlists_tab_bar_holder');

    let offset = 0;
    if (WLTabBar) {
      const tabTop = WLTabBar.getBoundingClientRect().top;
      offset = tabTop <= 0 ? window.pageYOffset + tabTop : 0;
    }

    if (offset) {
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }
    if (this.storiesRef.current) {
      this.storiesRef.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
    this.setState({
      newStoriesAvailable: false,
    });

    if (fetchNewStories) {
      this.loadStories({ ...storyFilters, isScrollTop: true });
    }
  }

  async loadStories(filters, nextPage = false) {
    const {
      storyFilters,
      freezeStories,
    } = this.props;
    if (!storyFilters.conflictsChecked) return;
    const { isFilterFixed } = this.state;

    clearTimeout(this.loadStoriesTimeout);
    // Load stories when only when second timeout call when be the same value and not frozen
    if (filters.refresh_rate === storyFilters.refresh_rate && !freezeStories
      && (!filters.isTimeout
        || (filters.isTimeout && !isFilterFixed && !this.scrollDivTop))
      && this.isTabActive) {
      await this.storiesLoader(!nextPage, filters.isRefresh);
    }

    if (filters.isScrollTop) {
      clearTimeout(this.storyUpdateTimer);
      this.storyUpdateTimer = 0;
      this.loadStoriesTimeout = setTimeout(
        this.loadStories,
        filters.refresh_rate,
        { ...storyFilters, isTimeout: true },
      );
      return;
    }

    if (filters.refresh_rate !== 'never' && Number(filters.refresh_rate) && this.isTabActive) {
      if (nextPage || isFilterFixed || this.scrollDivTop) {
        if (!this.storyUpdateTimer) {
          this.storyUpdateTimer = setTimeout(this.checkForUpdate, filters.refresh_rate);
        }
      } else {
        clearTimeout(this.storyUpdateTimer);
        this.storyUpdateTimer = 0;
        this.loadStoriesTimeout = setTimeout(
          this.loadStories,
          filters.refresh_rate,
          { ...storyFilters, isTimeout: true },
        );
      }
    }
  }

  // loading stories for search page, wl guest users
  async storiesLoader(checkFreezingStories, isRefresh = false) {
    // terminate function if stories was frozen
    const {
      actions,
      activeWatchlist,
      token,
      freezeStories,
      storyFilters,
      stories,
      guestStories,
      activeWatchlistTopics,
      isWatchlistUpdatedProps,
      changeIsWatchlistUpdatedValue,
    } = this.props;

    if ((checkFreezingStories && freezeStories) || !storyFilters.conflictsChecked) return;

    const storyData = () => (stories.length ? stories : guestStories);

    if (storyData().length === 0) actions.activatePreloader();

    const params = this.getParams(storyFilters);

    if (storyData().length) actions.updateWatchlistPageBegin();

    if (this.sourceCancelToken) this.sourceCancelToken.cancel();

    this.cancelToken = axios.CancelToken;
    this.sourceCancelToken = this.cancelToken.source();

    if (checkFreezingStories) {
      clearTimeout(this.loadStoriesTimeout);
      clearTimeout(this.storyUpdateTimer);
    }

    this.setState({
      storyUpdateApiCall: true,
    });

    let res;
    if (token) {
      const { isWatchlistUpdated } = this.state;
      res = await actions.getWatchlistStories({
        watchlistId: activeWatchlist.id,
        params,
        nextPage: false,
        query: params.query,
        cancelToken: this.sourceCancelToken.token,
        isRefresh: isRefresh || isWatchlistUpdated || isWatchlistUpdatedProps,
      });
    } else {
      const query = watchlistTopicsQueryCreator(
        // Include no more than 33 topics
        // to not exceed URL length limit (2048 characters)
        activeWatchlistTopics.filter((item) => !item.hidden).slice(0, 33),
        token,
      );
      res = await actions.loadGuestWatchlistStories({
        query,
        params: { ...params, query },
        cancelToken: this.sourceCancelToken.token,
      });
    }
    changeIsWatchlistUpdatedValue(false);
    this.setState({
      storyUpdateApiCall: false,
      isWatchlistUpdated: false,
    }, () => {
      const { wlPageLoadingStep, actions } = this.props;
      if (wlPageLoadingStep !== 'LOADED' && !res?.cancelled && res?.stories?.length >= 6) {
        actions.setWatchlistLoadStatus('LOADED');
      }
    });
  }

  async checkForUpdate() {
    const {
      storyFilters,
      stories,
      token,
      activeWatchlist,
    } = this.props;

    const params = this.getParams(storyFilters);
    const extra = {
      cancelToken: this.sourceCancelToken.token,
    };

    let storiesRequest;
    if (token) {
      if (params.include_all_topics) {
        storiesRequest = loadWatchlistStories(activeWatchlist.id, params, extra);
      } else {
        storiesRequest = getStories({
          ...params,
          ...filterSourceDomains(params),
          cancelToken: this.sourceCancelToken.token,
        });
      }
    } else {
      storiesRequest = getStories({
        ...params,
        ...filterSourceDomains(params),
        query: watchlistTopicsQueryCreator(activeWatchlist.search_queries),
        cancelToken: this.sourceCancelToken.token,
      });
    }

    const {
      stories: newStories,
      cancelled,
    } = await storiesRequest;

    if (cancelled) return;

    const nonDuplicateStoriesIds = new Set([
      ...stories.slice(0, STORIES_LIMIT).map(({ id }) => id),
      ...newStories.map(({ id }) => id),
    ]);

    if (nonDuplicateStoriesIds.size > STORIES_LIMIT) {
      this.setState({
        newStoriesAvailable: true,
      });
    } else {
      const { isFilterFixed } = this.state;
      if (isFilterFixed || this.scrollDivTop) {
        this.storyUpdateTimer = setTimeout(this.checkForUpdate, storyFilters.refresh_rate);
      } else {
        clearTimeout(this.storyUpdateTimer);
        this.storyUpdateTimer = 0;
        this.loadStoriesTimeout = setTimeout(this.loadStories, storyFilters.refresh_rate,
          { ...storyFilters, isTimeout: true });
      }
    }
  }

  fetchNewStories() {
    const {
      actions,
      token,
      activeWatchlist,
      storyFilters,
      nextPageToken,
    } = this.props;

    this.setState({
      newStoriesLoading: true,
    });

    const params = {
      ...this.getParams(storyFilters),
      ...(nextPageToken && {
        page_token: nextPageToken,
      }),
    };
    let storiesPromise;

    if (token) {
      storiesPromise = actions.getWatchlistStories({
        watchlistId: activeWatchlist.id,
        params,
        query: params.query,
        nextPage: true,
        cancelToken: this.sourceCancelToken.token,
      });
    } else {
      const query = watchlistTopicsQueryCreator(activeWatchlist.search_queries);
      storiesPromise = actions.loadGuestWatchlistStories({
        query,
        params,
        nextPage: true,
        cancelToken: this.sourceCancelToken.token,
      });
    }

    storiesPromise.then((data) => {
      if ((data || {}).cancelled) {
        return;
      }
      this.setState({
        newStoriesLoading: false,
      });
      if (storyFilters.refresh_rate !== 'never' && Number(storyFilters.refresh_rate) && !this.storyUpdateTimer) {
        this.storyUpdateTimer = setTimeout(this.checkForUpdate, storyFilters.refresh_rate);
      }
    });

    return storiesPromise;
  }

  toggleStoryFilters() {
    this.setState(({ filterOpened }) => ({
      filterOpened: !filterOpened,
      personalisationExpand: false,
    }));
  }

  togglePersonalisationFilters() {
    this.setState(({ personalisationExpand }) => ({
      filterOpened: false,
      personalisationExpand: !personalisationExpand,
    }));
  }

  handleRefreshEvent() {
    const { storyFilters, piwikEnabled } = this.props;
    this.setState({
      newStoriesAvailable: false,
    });
    this.scrollToStart(false);
    this.loadStories({
      ...storyFilters,
      isRefresh: true,
    });

    if (piwikEnabled) {
      _paq.push(['trackEvent', 'WL News', 'Refresh:']);
    }
  }

  render() {
    const {
      stories,
      watchlistPageUpdate,
      activatePreloader,
      guestStories,
      guestUserWlReplacement,
      user,
      storyFilters,
      actions,
      activeWatchlistTopics,
      token,
      piwikEnabled,
      nextPageToken,
      summaryRequestMethod,
      filterOpened,
      onSimplifiedViewTabsClick,
      isAdvancedLayout,
      watchlistPageLoad,
      watchlistLoadError,
      wlPageLoadingStep,
    } = this.props;

    const {
      width,
      newStoriesAvailable,
      newStoriesLoading,
      isFilterFixed,
      filterTop,
      isNewStoriesFixed,
      scrollUpTop,
    } = this.state;

    const isCompactView = isMobileOnly ? (
      storyFilters.user_newsfeed_compactview
    ) : (
      storyFilters.user_newsfeed_compactview_web
    );
    const userNewsfeedView = isMobileOnly ? (
      storyFilters.user_newsfeed_view
    ) : (
      storyFilters.user_newsfeed_view_web
    );
    const isTilesView = userNewsfeedView === 'tiles' && !isCompactView;
    const watchlistWrapperClass = cx({
      watchlist_wrapper: true,
      simpleLayout: isAdvancedLayout,
      simpleLayoutUser: isAdvancedLayout && token,
      tiles: isTilesView,
    });

    const storiesListClass = cx({
      stories_list: true,
      updating_watchlist: !activatePreloader && watchlistPageUpdate,
      guest_user_watchlist_removing: guestUserWlReplacement,
    });

    const newFilingsClass = cx('new_stories_btn',
      { visible: newStoriesAvailable, fixed: isFilterFixed && width > 767 });
    const newFilingsMobikeClass = cx('new_stories_btn',
      { show: newStoriesAvailable, fixed: isNewStoriesFixed });

    const storyData = () => (stories.length ? stories : guestStories);
    const storyDivMainHeight = (this.storiesRef.current || {}).offsetHeight;

    const activeTopics = activeWatchlistTopics.filter((item) => !item.hidden && item?.entity_type?.toLowerCase() !== 'query')
      .map((item) => {
        if (item.query) {
          return queryItemWatchlistParser(item.query);
        }

        return {
          name: item.name,
          type: item.entity_type,
        };
      });

    const allowMasonry = isTilesView && width > 767;
    const StoriesWrapper = allowMasonry ? Masonry : 'div';
    const storiesWrapperProps = {
      className: cx({
        tiles_wrapper: isTilesView,
        without_tiles: !isTilesView,
        without_compact: !isCompactView,
      }),
      ...(allowMasonry && {
        disableImagesLoaded: true,
        options: {
          gutter: 10,
          percentPosition: true,
          resize: false,
          isResizeBound: false,
          transitionDuration: 0,
        },
        ref: (c) => { this.masonry = this.masonry || c.masonry; },
      }),
    };

    return (
      <div hidden={wlPageLoadingStep !== 'LOADED'} className={watchlistWrapperClass} ref={this.storiesContainerRef}>
        <div className={Styles.watchlist_filter_buttons}>
          <div className={Styles.filters_container}>
            <OpenFiltersButton
              watchlistRefresh
              refreshEvent={this.handleRefreshEvent}
              onSimplifiedViewTabsClick={onSimplifiedViewTabsClick}
              isSimpleLayout={isAdvancedLayout}
            />
            <NewStoriesButton
              className={newFilingsClass}
              onClick={this.scrollToStart}
              style={{ top: `${isFilterFixed && width > 767 ? filterTop + 15 : 0}px` }}
            />
          </div>
          <PiwikContext.Consumer>
            {(value) => (
              <StoryFilters
                mobileWlFilters
                watchlistRefresh
                piwikEnabled={value.piwikEnabled}
                user={user}
                isSimpleLayout={isAdvancedLayout}
                onSimplifiedViewTabsClick={onSimplifiedViewTabsClick}
              />
            )}
          </PiwikContext.Consumer>
        </div>
        <div
          ref={this.mobileNewStoriesRef}
          className={cx('new_stories_btn_mobile', { show: newStoriesAvailable })}
        >
          <NewStoriesButton
            className={newFilingsMobikeClass}
            onClick={this.scrollToStart}
          />
        </div>
        <Summarisation
          storiesEndpoint={summaryRequestMethod}
          page="watchlist"
          isTilesView={isTilesView}
          isHidden={!activatePreloader && !storyData().length}
          isWatchlist
        />
        <div className={storiesListClass}>
          {activatePreloader ? (
            <div className={Styles.watchlist_main_loader}>
              <Preloader loading className={Styles.external_loader} />
            </div>
          ) : (
            <div
              className={
                cx('stories', {
                  filter_open: filterOpened,
                  stories_tiles_wrapper: isTilesView,
                  stories_without_tiles: !isTilesView,
                  has_more: (
                    this.recommendedRef.current?.state?.isRecommendedStoriesLoading
                  ) || (nextPageToken !== 'EOD' && this.scrollDivTop > storyDivMainHeight),
                })
              }
              onScroll={this.onStoryScroll}
              ref={this.storiesRef}
            >
              <StoriesWrapper {...storiesWrapperProps}>
                {storyData()
                  .map((story, index) => (
                    <StoryCard
                      key={story.id}
                      story={story}
                      user={user}
                      type={story.type}
                      onHide={this.onStoryHide}
                      onFreezeStories={actions.freezeStories}
                      onLikeChanged={actions.updateWatchlistStoriesInfo}
                      onBookmarkClick={actions.updateWatchlistStoriesBookmark}
                      piwikEnabled={piwikEnabled}
                      loading={watchlistPageUpdate}
                      watchlistPage
                      masonryObj={this.masonry}
                      index={index}
                      isWatchlist
                      activeTopics={activeTopics}
                      scrollDivTop={this.scrollDivTop}
                      hasBigScreenDesign
                      storiesRef={this.storiesRef}
                    />
                  ))}
              </StoriesWrapper>
              {newStoriesLoading && (
                <Preloader
                  loading
                  static
                  centered
                  style={{
                    height: '200px',
                  }}
                />
              )}
              {!watchlistPageLoad && !watchlistLoadError
              && storyData().length < 20 && nextPageToken === 'EOD' && !activatePreloader && (
                <RecommendedStories
                  ref={this.recommendedRef}
                  query={(
                    watchlistTopicsQueryCreator(
                      // Include no more than 33 topics
                      // to not exceed URL length limit (2048 characters)
                      activeWatchlistTopics.filter((item) => !item.hidden).slice(0, 33),
                      token,
                    )
                  )}
                  loadingStories={watchlistPageUpdate}
                  storiesLength={storyData().length}
                  watchlistPage
                  isAdvancedView={isAdvancedLayout}
                  oldStories={storyData()}
                />
              )}
              {
                storyData().length >= 30 && nextPageToken === 'EOD' && (
                  <StoryCaughtUp hideButton />
                )
              }
              <button
                type="button"
                aria-label="scroll-up-button"
                className={cx('scroll-up-button', { hide: !this.scrollDivTop })}
                onClick={this.scrollToStart}
                style={{ top: `${scrollUpTop}px` }}
              >
                <FontAwesomeIcon icon={faChevronUp} />
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  watchlistReducer,
  stories,
  storyFilters,
  searchReducers,
  userPreferencesReducer,
  common,
  promobar,
  subscriptions,
}) => ({
  activeWatchlist: watchlistReducer.activeWatchlist,
  activeWatchlistTopics: watchlistReducer.activeWatchlistTopics,
  stories: StoriesSvc.filterStories(watchlistReducer.activeWatchlistStories, storyFilters),
  internalStories: watchlistReducer.activeWatchlistInternalStories,
  freezeStories: stories.freeze_stories,
  assets: watchlistReducer.activeWatchlistTopics,
  storyFilters,
  loadingPage: watchlistReducer.loading,
  internalLoading: watchlistReducer.internalLoading,
  watchlistPageUpdate: watchlistReducer.watchlistPageLoad,
  activatePreloader: watchlistReducer.activatePreloader,
  token: watchlistReducer.userToken,
  guestStories: searchReducers.stories,
  guestUserWlReplacement: watchlistReducer.guestUserWlReplacementBegin,
  userPreferences: userPreferencesReducer.preferences,
  nextPageToken: watchlistReducer.nextPageToken,
  summaryRequestMethod: watchlistReducer.summaryRequestMethod,
  scrollUpPressed: common.scrollUpPressed,
  promobarHeight: promobar.height,
  filterOpened: userPreferencesReducer.filterOpened,
  accessLevels: subscriptions.permissions.access_levels,
  watchlistLoadError: watchlistReducer.watchlistLoadError,
  watchlistPageLoad: watchlistReducer.watchlistPageLoad,
  wlPageLoadingStep: watchlistReducer.wlPageLoadingStep,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    ...watchlistActions,
    ...searchActions,
    ...storyActions,
    ...preferencesActions,
    ...commonActions,
  }, dispatch),
});

export default withComponentName(connect(
  mapStateToProps,
  mapDispatchToProps,
)(permissionsDecorator(withMetatag(WatchlistNews, 'watchlists/news'))));
